// extracted by mini-css-extract-plugin
export default {"pageHeight":"Notifications_pageHeight__YS2Rp","duploLogoOpaque":"Notifications_duploLogoOpaque__xEt1b"};